module.exports = __webpack_public_path__ + "img/insta-dist.b1a1f66d.svg";